import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

const ErrorPageContainer = styled.div`
  min-height: 75vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem;

  h1 {
    font-size: 1.75rem;
    font-weight: 700;
    margin: 36px 0;
  }

  p {
    font-size: 1.25rem;
    font-weight: 500;
    margin: 18px 0;
  }
`;

const Link = styled(NavLink)`
  color: white;
  cursor: pointer;
`;

const ErrorPage = (): JSX.Element => {
  return (
    <ErrorPageContainer>
      <h1>404 - Page Not Found</h1>
      <p>
        Oops! The page you are looking for does not exist or might have been
        moved.
      </p>
      <p>
        Please check the URL for any typos or navigate back to the homepage to
        find what you&apos;re looking for.
      </p>
      <Link to='/'>Back to the homepage</Link>
    </ErrorPageContainer>
  );
};

export default ErrorPage;
